import AttributesCollection from './core/AttributeCollection';
import Attribute from './core/Attribute';
import Model from './Model';

export default class UserDailyPlanning extends Model {
  public userId: number;
  public dayOfWeek: number;
  public startTime: string;
  public endTime: string;
  public creneau1: number;
  public creneau2: number;
  public creneau3: number;
  public creneau4: number;
  public creneau5: number;

  static readonly modelUrl = "user_daily_plannings";
  public modelName = "userDailyPlanning";

  public attributes = new AttributesCollection({
    userId: new Attribute("userId"),
    dayOfWeek: new Attribute("dayOfWeek"),
    startTime: new Attribute("startTime"),
    endTime: new Attribute("endTime"),
    creneau1: new Attribute("creneau1"),
    creneau2: new Attribute("creneau2"),
    creneau3: new Attribute("creneau3"),
    creneau4: new Attribute("creneau4"),
    creneau5: new Attribute("creneau5"),
  });

  constructor(json) {
    super(json);
    this.fillAttributes(json);
  }
}
